import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './PageInfo.css';

class PageInfo extends Component {
    render() {
        return (
            <div className="mainBox-header">
                <img src={this.props.imgIcon} className="mainBox-img" />
                <div className="mainBox-content">
                    <div className="mainBox-heading">
                        {this.props.pageTitle}
                    </div>
                    <p>{this.props.pageContent}</p>
                </div>
            </div>
        )
    }
}

PageInfo.propTypes = {
    imgIcon: PropTypes.string,
    pageTitle: PropTypes.string,
    pageContent: PropTypes.string
}

export default PageInfo;